import React, {useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserCards } from '../../services/card_collection'
import CollectionDisplay from './CollectionDisplay';


const CardCollection = () => {
    const user = useSelector(state => state.session.user);
    const [ loading, setLoading ] = useState(true);
    const [ cards, setCards ] = useState(null);

    useEffect(() => {
        (async () => {
            let organizedCards = {
                box:[]
            }
            const allCards = await getUserCards(user.id);
            organizedCards.allCards = allCards.cards;
            organizedCards.decks = allCards.decks;
            // Every deck gets an entry even if it currently has no cards,
            // so CollectionDisplay never indexes into an undefined array.
            allCards.decks.forEach(deck => {
                organizedCards[deck.id] = [];
            })
            allCards.cards.forEach(card => {
                if(card.deck_id){
                    organizedCards[card.deck_id].push(card);
                }else {
                    organizedCards.box.push(card)
                }
            })
            setCards(organizedCards);
            setLoading(false);
        })()
    }, [])

    return (
        <div>
            {loading && (<h3>loading...</h3>)}
            {!loading && cards && (
                <CollectionDisplay cards={cards} />
            )}
        </div>
    )
}

export default CardCollection;